import React, { useCallback, useEffect, useState } from 'react';
import { styled } from 'baseui';
import { useAtomValue } from 'jotai';
import { useStageAtoms } from '../../../labelling-v2/components/stage-scope/hooks';
import { TOOL } from '../../constants';
import { CSS_VARIABLE_STAGE_VISIBLE_SCALE } from '../../constants/stage-css-variables';
import useShortcut from '../../providers/hooks/use-shortcut';
import useStage from '../../providers/hooks/use-stage';
import { type StagePointerEventT } from '../../providers/stage-provider';
import { handleShortcutRegistrationError } from '../../providers/utils/shortcut';
import { CROSS_HAIR_LINE_COLOR_ORDER } from './constants';
const Line = styled<'line', {
  $color: string;
}>('line', ({
  $color
}) => ({
  transformBox: 'fill-box',
  strokeWidth: `var(${CSS_VARIABLE_STAGE_VISIBLE_SCALE})`,
  stroke: `${$color}`
}));
const CrossHair = () => {
  const {
    stage,
    onStage
  } = useStage();
  const {
    selectedToolAtom
  } = useStageAtoms();
  const selectedTool = useAtomValue(selectedToolAtom);
  const [mousePos, setMousePos] = useState([0, 0]);
  const {
    registerHotKeys
  } = useShortcut();
  const [lineColor, setLineColor] = useState(CROSS_HAIR_LINE_COLOR_ORDER[0]);
  const onPointerMove = useCallback((stageEvent: StagePointerEventT) => {
    const {
      mousePos
    } = stageEvent.detail;
    setMousePos(mousePos);
  }, []);
  const onDrag = useCallback((stageEvent: StagePointerEventT) => {
    const {
      mousePos
    } = stageEvent.detail;
    setMousePos(mousePos);
  }, []);
  const handleHotKeyPress = useCallback(() => {
    setLineColor(CROSS_HAIR_LINE_COLOR_ORDER[
    // @ts-expect-error todo(ts-migration) TS2345 Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
    (CROSS_HAIR_LINE_COLOR_ORDER.indexOf(lineColor) + 1) % CROSS_HAIR_LINE_COLOR_ORDER.length]);
  }, [lineColor]);
  useEffect(() => {
    const {
      errors,
      removeHotKeys
    } = registerHotKeys([{
      keys: ['x'],
      onAction: handleHotKeyPress
    }]);
    errors.forEach(error => handleShortcutRegistrationError(error));
    return () => {
      removeHotKeys();
    };
  }, [registerHotKeys, handleHotKeyPress]);
  useEffect(() => {
    if (!stage) return;
    stage.addEventListener('pointermove', onPointerMove);
    stage.addEventListener('drag', onDrag);
    return () => {
      stage.removeEventListener('pointermove', onPointerMove);
      stage.removeEventListener('drag', onDrag);
    };
  }, [stage, onPointerMove, onDrag, handleHotKeyPress]);
  return <svg height="100%" width="100%">
      {selectedTool !== TOOL.POINTER && onStage && <>
          {/* @ts-expect-error todo(ts-migration) TS2322 Type 'string | undefined' is not assignable to type 'string'. */}
          <Line x1="0" y1={mousePos[1]} x2="100%" y2={mousePos[1]} $color={lineColor} />
          {/* @ts-expect-error todo(ts-migration) TS2322 Type 'string | undefined' is not assignable to type 'string'. */}
          <Line x1={mousePos[0]} y1="0" x2={mousePos[0]} y2="100%" $color={lineColor} />
        </>}
    </svg>;
};
export default CrossHair;